/** Same command `NodeDeviceListElement`/`ProfileStageElement` already use to list paired
 * client devices (`device-session-client.ts#listDevices`, wired through the host's
 * `ClientDeviceCommandDispatcher` — see `system/pwa/src/kernel-runtime.ts`). Each row now
 * carries `isCurrent`, derived server-adapter-side by comparing the row's `deviceId` against
 * the already-established `DeviceSession.deviceId` the pairing/session layer holds — no new
 * backend round-trip, no new capability. */
const DEVICES_COMMAND = "client-device.list.v1";
/**
 * Resolves the paired-device row THIS session is authenticated as, for the identity chip
 * (`pmenu.ts`'s `.pmenu-id-name` / `topbar.ts`'s `.u-name`) — replaces the hard-coded
 * `"Node"` label the debt note (`docs/architecture/client-node-debt.md` item 3) flags.
 *
 * Returns `undefined` on any failure (offline, host command not yet registered, no
 * `isCurrent` row found) rather than throwing — callers fall back to `currentDeviceLabel`'s
 * own generic label, never a crash or a blank chip.
 */
export async function loadCurrentDevice(client) {
    let rows;
    try {
        rows = await client.command(DEVICES_COMMAND, { includeRevoked: false });
    }
    catch {
        return undefined;
    }
    const current = rows.find((row) => row.isCurrent === true);
    if (current === undefined)
        return undefined;
    const deviceId = typeof current.deviceId === "string" ? current.deviceId : undefined;
    if (deviceId === undefined || deviceId === "")
        return undefined;
    const name = typeof current.deviceName === "string" ? current.deviceName.trim() : "";
    return { deviceId, name };
}
/**
 * Display text for the identity chip: the device's real paired name when one is set, else
 * the short device-id form, else the shell's own generic fallback — never blank, never the
 * literal `"Node"` placeholder.
 */
export function currentDeviceLabel(device) {
    if (device === undefined)
        return "This device";
    if (device.name !== "")
        return device.name;
    return `Device ${device.deviceId.slice(0, 8).toUpperCase()}`;
}
//# sourceMappingURL=current-device.js.map